export const useColon = (str: string) => {
    const i18n = useI18n();
    if (i18n.locale.value === "en") {
        return str + ": ";
    } else {
        return str + "：";
    }
};
